import {mount} from 'svelte';

import * as Utils from '@js/modules/utils';
import {videoLazyLoader} from '@js/modules/videoLazyLoader';
import AnimateElement from '@js/modules/animateElement';
import Testimonials from '@js/modules/testimonials';

import I18n from '@js/modules/translations';

import PlannerSearch from '@js/components/planner/PlannerSearch.svelte';
import PlannedRides from '@js/components/ride/list/PlannedRides.svelte';

const PlannerMap = () => import('@js/components/planner/PlannerMap.svelte');
const PlannerRouteDetails = () => import('@js/components/planner/PlannerRouteDetails.svelte');
const PlannerRouteInfo = () => import('@js/components/planner/PlannerRouteInfo.svelte');

const RideCreation = () => import('@js/components/ride/RideCreation.svelte');


class PlannerManager {
    _$rideType = document.getElementById('ride-type');

    _model = {
        rideType: null,
        mapId: 'planner-map'
    };

    _components = {
        $searchForm: document.getElementById('planner-search'),
        $map: document.getElementById('planner-map-container'),
        $routeDetails: document.getElementById('planner-route-details'),
        $routeInfo: document.getElementById('planner-route-info'),
        $rideCreation: document.getElementById('planner-ride-creation'),
        $plannedRides: document.getElementById('planner-planned-rides')
    };

    /* Public methods
    ******************** */
    constructor() {
        this._model.rideType = this._$rideType.innerText;
    }

    initialize = () => {
        this._mountComponents();

        this._mountAsyncComponents();

        AnimateElement.initialize();

        videoLazyLoader();

        Testimonials.initialize();
    };

    /* Private methods
    ******************** */
    _mountComponents = () => {
        mount(PlannerSearch, {
            target: this._components.$searchForm,
            props: {
                rideType: this._model.rideType,
                mapId: this._model.mapId
            }
        });

        mount(PlannedRides, {
            target: this._components.$plannedRides,
            props: {
                class: 'main-section mt-24',
                title: I18n.t('js.views.planner.recents_planned')
            }
        });
    };

    _mountAsyncComponents = () => {
        Utils.onPageReady(() => {
            PlannerMap()
                .then(({default: PlannerMapComponent}) => {
                    mount(PlannerMapComponent, {
                        target: this._components.$map,
                        props: {
                            rideType: this._model.rideType,
                            mapId: this._model.mapId
                        }
                    });

                    // Class used for preserving space on initial load
                    this._components.$map.classList.remove('planner-map-container-preload');
                });

            setTimeout(() => {
                PlannerRouteDetails()
                    .then(({default: PlannerRouteDetailsComponent}) => {
                        mount(PlannerRouteDetailsComponent, {
                            target: this._components.$routeDetails,
                            props: {}
                        });
                    });

                PlannerRouteInfo()
                    .then(({default: PlannerRouteInfoComponent}) => {
                        mount(PlannerRouteInfoComponent, {
                            target: this._components.$routeInfo,
                            props: {}
                        });
                    });
            }, 800);

            setTimeout(() => {
                RideCreation()
                    .then(({default: RideCreationComponent}) => {
                        mount(RideCreationComponent, {
                            target: this._components.$rideCreation,
                            props: {
                                defaultRideVisibility: 'only_me',
                                defaultPlanned: true
                            }
                        });
                    });
            }, 2500);
        });
    };
}

export default new PlannerManager();
